import React, { Component } from 'react';
import FadeIn from '../../components/common/fadein'

class PageNotFoundComponent extends Component {
    render() {
        return (
            <div>
                <section className="content-page">
                    <FadeIn duration="slow">
                        <div className="content-content">
                            <h1 className="content-title">404</h1>
                            <p className="content-subtitle">Page Not Found</p>
                        </div>
                    </FadeIn>
                </section>
            </div>
        )
    }
}

export default PageNotFoundComponent
